import {
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Switch,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import CardForm from "components/ui/CardForm";
import { useStepperContext } from "components/ui/custom-stepper/CustomStepperContext";
import FixedBar from "components/ui/FixedBar";
import FormControlGroup from "components/ui/FormControlGroup";
import {
  ResourceCreatableSelect,
  ResourceSelect,
} from "components/ui/ResourceCreatableSelect";
import SubmitButton from "components/ui/SubmitButton";
import { CONTENT_GROUP_TYPE_NAMES } from "features/content-groups/components/ContentGroupsList";
import { useCreateListData } from "features/lists/contexts/CreateListDataContext";
import { ArrayRequiredTestFunction } from "lib/validation";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as Yup from "yup";

export interface FormValues {
  name: string;
  isNewsletter?: boolean;
  requiresReview?: boolean;
  tags: [];
  contentGroups: [];
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  tags: Yup.mixed().test("tags", "", ArrayRequiredTestFunction),
  contentGroups: Yup.mixed().test(
    "contentGroups",
    "",
    ArrayRequiredTestFunction
  ),
});

export default function FormCreateListData() {
  const { data, onSubmitData } = useCreateListData();
  const { nextStep } = useStepperContext();

  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm<FormValues>({
    mode: "all",
    resolver: yupResolver(validationSchema) as unknown as Resolver<FormValues>,
    defaultValues: {
      ...data,
      requiresReview: false,
    },
  });

  const isNewsletter = watch("isNewsletter");

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    onSubmitData(data);
    nextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Heading as="h1" size="h1">
        Dados da lista
        <span>Como a lista será identificada no sistema</span>
      </Heading>

      <CardForm>
        <FormControlGroup>
          <FormControl isInvalid={!!errors.name} isRequired>
            <FormLabel>Nome</FormLabel>
            <Input {...register("name")} />
          </FormControl>
        </FormControlGroup>

        <FormControlGroup>
          <FormControl
            as={Flex}
            align="center"
            gap="10px"
            maxWidth="280px"
            isInvalid={!!errors.isNewsletter}
          >
            <Switch id="email-alerts" {...register("isNewsletter")} />
            <FormLabel htmlFor="email-alerts" mb="0">
              Lista de Newsletter
            </FormLabel>
          </FormControl>

          {isNewsletter && (
            <FormControl
              as={Flex}
              align="center"
              gap="10px"
              maxWidth="280px"
              isInvalid={!!errors.requiresReview}
            >
              <Switch id="requires-review" {...register("requiresReview")} />
              <FormLabel htmlFor="requires-review" mb="0">
                Necessário revisar antes do envio
              </FormLabel>
            </FormControl>
          )}
        </FormControlGroup>

        <FormControlGroup>
          <FormControl isInvalid={!!errors.contentGroups} isRequired>
            <FormLabel>Operação</FormLabel>
            <ResourceSelect
              control={control}
              name="contentGroups"
              resourceKey="contentGroups"
              listPath="/content-groups"
              nameFormat={(record) =>
                `${CONTENT_GROUP_TYPE_NAMES[record.type]} - ${record.name}`
              }
              isMulti
              placeholder="Selecione uma opção"
            />
          </FormControl>
          <FormControl isInvalid={!!errors.tags} isRequired>
            <FormLabel>Tags</FormLabel>
            <ResourceCreatableSelect
              control={control}
              name="tags"
              resourceKey="tags"
              listPath="/tags/LIST"
              createPath="/tags"
              createData={{ type: "LIST" }}
              isMulti
              placeholder="Selecione uma opção"
            />
          </FormControl>
        </FormControlGroup>

        <FixedBar>
          <SubmitButton isDisabled={!isValid}>Continuar</SubmitButton>
        </FixedBar>
      </CardForm>
    </form>
  );
}
